var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "checkbox",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 122 122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e73d49b9-3439-4310-8f36-6ebcd17b222b{fill:none;}.a1d166c3-c135-41e8-9354-f2d597b9b85c{clip-path:url(#e304f13b-58ce-4ea4-a7e0-0561e00e5b90);}.a6f296d0-3d3b-4de2-8d12-4195e7c09b71{fill:#4caf50;}.badbbbbb-ae76-446b-80cd-15cf1ae1dcc1{fill:#fafafa;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "e304f13b-58ce-4ea4-a7e0-0561e00e5b90"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e73d49b9-3439-4310-8f36-6ebcd17b222b",
    width: 122,
    height: 122
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b42942cd-8fdd-4bf1-aeee-141e8db10d0b",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bbaa366c-16a4-4ce5-9220-82dd1567d911",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a1d166c3-c135-41e8-9354-f2d597b9b85c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a6f296d0-3d3b-4de2-8d12-4195e7c09b71",
    d: "M122,14A14,14,0,0,0,108,0H14A14,14,0,0,0,0,14v94a14,14,0,0,0,14,14h94a14,14,0,0,0,14-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "badbbbbb-ae76-446b-80cd-15cf1ae1dcc1",
    d: "M91.92,40.89a5.08,5.08,0,0,1,0,7.18l-33,33a5.08,5.08,0,0,1-7.19,0L35.17,64.59a5.08,5.08,0,0,1,7.18-7.18L55.28,70.33,84.73,40.89A5.08,5.08,0,0,1,91.92,40.89Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.684e6861cdb711f980362fefe0c786e9.svg";
export { ForwardRef as ReactComponent };